module.exports = __webpack_public_path__ + "img/icon37.34b3dd10.png";